import React from "react";
import { Link } from "react-router-dom";
import "../css/Lp2App.css";

const Dashboard: React.FC = () => {
  return (
    <div className="lp2app">
      <h1 className="lp2app__title">BootLoop Dashboard</h1>
      <p className="lp2app__lead">What do you want to do today?</p>

      <div className="lp2app__grid2">
        <div className="lp2app__card">
          <h2 style={{ margin: "0 0 6px" }}>List your boots</h2>
          <p className="lp2app__lead" style={{ marginBottom: 0 }}>
            Add a pair in under a minute — size, type, condition, notes.
          </p>
          <div className="lp2app__actions">
            <Link to="/list-boots" className="lp2app__btnPrimary">
              List boots
            </Link>
          </div>
        </div>

        <div className="lp2app__card">
          <h2 style={{ margin: "0 0 6px" }}>Find a swap</h2>
          <p className="lp2app__lead" style={{ marginBottom: 0 }}>
            Search by size and boot type. Local-first matching later.
          </p>
          <div className="lp2app__actions">
            <Link to="/find-swap-v2" className="lp2app__btnSecondary">
              Find a swap
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
